import * as actionTypes from './types';
var _ = require('lodash');

const initialState = {
  profile: [],
  isDisabled: true,
};

const profileReducer = (
  state = initialState,
  action: {type: string; payload: any},
) => {
  switch (action.type) {
    case actionTypes.ADD_PROFILE:
      return {
        ...state,
        profile: [...state.profile, action.payload],
        isDisabled: false,
      };
    case actionTypes.SET_PROFILE:
      return {...state, profile: action.payload};
    case actionTypes.SELECT_ALL_PROFILES:
      var union = _.union([...state.profile], action.payload);
      var finalArray = _.uniqWith(union, _.isEqual);
      return {...state, profile: finalArray, isDisabled: false};
    case actionTypes.REMOVE_PROFILE:
      const filterProfile = state.profile.filter(
        (profile: any) => profile.iD_Profile !== action.payload.iD_Profile,
      );
      return {...state, profile: [...filterProfile], isDisabled: false};
    case actionTypes.REMOVE_PROFILE_SPAC:
      const filterProfileSpac = state.profile.filter(
        (profile: any) =>
          profile.iD_ProfileSpac !== action.payload.iD_ProfileSpac,
      );
      return {...state, profile: [...filterProfileSpac], isDisabled: false};
    case actionTypes.REMOVE_ALL_PROFILE:
      return {...state, profile: [], isDisabled: false};
    case actionTypes.CLEAN:
      return {
        ...state,
        profile: [],
        isDisabled: true,
        type: '',
      };
    case actionTypes.DISABLED_BUTTON:
      return {...state, isDisabled: true};
    default:
      return state;
  }
};

export default profileReducer;
